// @flow

import {combineReducers, createStore, compose, applyMiddleware} from "redux";
import persistState from "redux-localstorage";
import thunk from "redux-thunk";

import Backend from "./Middleware/Backend";
import Middleman from "./Middleware/Middleman";
import CrashReporter from "./Middleware/CrashReporter";

import {getAllQueryParams} from "../Utils/AppUtils";
import CurrentProposalReducer from "./Ducks/CurrentProposal";
import AppReducer from "./Ducks/App";
import CurrentRequestReducer from "./Ducks/CurrentRequest";
import TokenDataReducer from "./Ducks/TokenData";
import CurrentRideReducer from "./Ducks/CurrentRide";
import ServiceConfigReducer from "./Ducks/ServiceConfig/reducers";
import OriginAutocompleteReducer from "./Ducks/OriginAutocomplete/reducers";
import DestAutocompleteReducer from "./Ducks/DestAutocomplete/reducers";
import MapDataReducer from "./Ducks/MapData/reducers";

import type {TokenData} from "./Ducks/TokenData/reducers";
import type {DestAutocomplete} from "./Ducks/DestAutocomplete/reducers";
import type {CurrentRequest} from "./Ducks/CurrentRequest/reducers";
import type {CurrentProposal} from "./Ducks/CurrentProposal/reducers";
import type {CurrentRide} from "./Ducks/CurrentRide/reducers";
import type {MapData} from "./Ducks/MapData/reducers";
import type {App} from "./Ducks/App/reducers";
import type {ServiceConfig} from "./Ducks/ServiceConfig/reducers";
import type {OriginAutocomplete} from "./Ducks/OriginAutocomplete/reducers";
import {ActiveServerRideStatuses} from "./Ducks/CurrentRide/utils";
import {StopSelection} from "./Ducks/CurrentRequest/utils";

const allReducers = combineReducers({
    tokenData: TokenDataReducer,
    currentRequest: CurrentRequestReducer,
    currentProposal: CurrentProposalReducer,
    currentRide: CurrentRideReducer,
    mapData: MapDataReducer,
    app: AppReducer,
    serviceConfig: ServiceConfigReducer,
    originAutocomplete: OriginAutocompleteReducer,
    destAutocomplete: DestAutocompleteReducer,

});

export type State = {
    tokenData: TokenData,
    currentRequest: CurrentRequest,
    currentProposal: CurrentProposal,
    currentRide: CurrentRide,
    mapData: MapData,
    app: App,
    serviceConfig: ServiceConfig,
    originAutocomplete: OriginAutocomplete,
    destAutocomplete: DestAutocomplete
}

export type GetState = () => State;

const persistStateSlicer = (paths: string | Array<string>) => (state: State): State => {
    let currentRide = state.currentRide;
    let currentProposal;
    const thereIsAnActiveRide = currentRide && currentRide.ride_status && ActiveServerRideStatuses.includes(currentRide.ride_status);
    const thereIsAnActiveFlexProposal = currentRide && currentRide.awaitingDriverApproval;
    if (thereIsAnActiveRide || thereIsAnActiveFlexProposal) {
        currentRide = {
            ...state.currentRide,
            walkingMap: undefined,
        };
        currentProposal = state.currentProposal && state.currentProposal.valid ? state.currentProposal : {};
    } else {
        currentRide = {};
        currentProposal = {};
    }
    return {
        ...state,
        app: {
            ...state.app,
            loadingSemaphore: 0,
            riderLocation: undefined,
            alert: undefined,
            technicalIssue: undefined,
        },
        mapData: {},
        currentRequest: {
            ...state.currentRequest,
            dest_selection: StopSelection.NONE,
        },
        currentProposal: currentProposal,
        currentRide: currentRide,
        tokenData: {
            ...state.tokenData,
            error: undefined,
        },
    };

};
const isTestingEnv = ["development", "test"].includes(process.env.NODE_ENV);
const composeEnhancers = isTestingEnv ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

export default createStore(
    allReducers,
    {},
    composeEnhancers(
        applyMiddleware(thunk, /* CrashReporter, */ Backend, Middleman),

        persistState(//should be last
            null,
            {
                key: `Via_${getAllQueryParams().token}`,
                slicer: persistStateSlicer
            }),
    )
);



// WEBPACK FOOTER //
// ./src/Store/Store.js